import React from "react";
import ProductModal from "../../components/Modal/ProductModal";
import HeaderFour from "../../components/Header/HeaderFour";
import ShopDetailsMain from "./ShopDetailsMain";
import Footer from "../../components/Footer";

const ShopDetails = () => {
  return (
    <>
      <ProductModal />

      <HeaderFour />

      <ShopDetailsMain />

      <Footer />
    </>
  );
};

export default ShopDetails;
